import { useEffect } from 'react'

const PIXEL_ID = '1238533994884848'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

function initPixel() {
  if (initialized || typeof window === 'undefined') return

  const f = window as any
  const b = document
  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  window.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  initPixel()
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  initPixel()
  window.fbq('track', 'AddToCart', {
    content_name: 'Adiós Hormone Belly - Plan Anti-Hinchazón 14 Días',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  })
}

export function useMetaPixel() {
  useEffect(() => {
    trackPageView()
  }, [])

  return { trackAddToCart }
}
